export const characters = [
  {
    id: "w01-c1",
    workId: "w01",
    name: "沈砚",
    actor: "沈砚",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20young%20man%20in%20a%20dark%20wool%20coat%20against%20a%20moody%20indigo%20backdrop%20with%20warm%20rim%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p01&orientation=portrait",
    identity: "建筑师 · 记忆旅人",
    tags: ["执念", "理性", "深爱"],
    background: "从小在雨城长大，习惯用建筑图纸记录情绪。十年前恋人顾清和不告而别，他把所有疑问都封进了那栋即将拆迁的老屋。",
    analysis: "沈砚是整部影片的“时间锚点”。他每一次回到雨中，表面是为了见人，实际上是反复确认自己当年的选择是否正确。角色弧光从“想改写过去”走向“接受并说出真相”，是全片情感落点所在。",
    timeline: [
      { label: "序章", event: "返乡处理老屋拆迁，第一次在时雨中遇见十年前的顾清和。" },
      { label: "中段", event: "连续进入雨中，却发现每次重逢都在改写现实，老友的记忆开始错乱。" },
      { label: "终章", event: "放弃重来，在雨停前把当年未说出口的话当面说完。" }
    ]
  },
  {
    id: "w01-c2",
    workId: "w01",
    name: "顾清和",
    actor: "顾清和",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20young%20woman%20with%20soft%20wavy%20hair%20in%20a%20pale%20coat%20against%20a%20misty%20indigo%20backdrop%20with%20warm%20amber%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p02&orientation=portrait",
    identity: "旧城书店主理人",
    tags: ["温柔", "隐瞒", "自由"],
    background: "留在旧城守着父亲留下的书店，是唯一记得时雨规律的人。十年前的离开并非背叛，而是为了替沈砚挡下一场家庭变故。",
    analysis: "顾清和承担了影片的“留白”。她始终比沈砚更早看清代价，因此她的克制与沉默，反而成了推动男主成长的关键力量。",
    timeline: [
      { label: "初遇", event: "在雨中的老书店与沈砚重逢，装作不认识。" },
      { label: "揭秘", event: "被追问当年离开的原因，仍选择把真相留给时间。" },
      { label: "告别", event: "在最后一次时雨中送走沈砚，独自留在折叠的城市里。" }
    ]
  },
  {
    id: "w02-c1",
    workId: "w02",
    name: "陆沉",
    actor: "陆沉",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20quiet%20young%20man%20in%20a%20warm%20knit%20sweater%20against%20a%20snowy%20pale%20indigo%20backdrop%2C%20soft%20winter%20light%20and%20gentle%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p03&orientation=portrait",
    identity: "小镇电台播音员",
    tags: ["内敛", "长情", "克制"],
    background: "在北方小镇电台主持午夜节目，习惯把想说的话录了又删。三个冬天在同一个小站遇见温栀，却始终只肯以朋友相称。",
    analysis: "陆沉是全片的“沉默主体”。他的隐忍不是懦弱，而是把对方的生活放在自己前面。角色张力来自那句始终没播出去的话。",
    timeline: [
      { label: "第一个冬天", event: "在候车室第一次分给温栀一半暖气。" },
      { label: "第二个冬天", event: "录下一段表白录音，最终没有播出。" },
      { label: "第三个冬天", event: "在旧录音带里听见自己当年的声音，终于释怀。" }
    ]
  },
  {
    id: "w02-c2",
    workId: "w02",
    name: "温栀",
    actor: "温栀",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20gentle%20young%20woman%20in%20a%20long%20grey%20coat%20against%20a%20snowy%20quiet%20indigo%20backdrop%20with%20soft%20warm%20glow%2C%20subtle%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p04&orientation=portrait",
    identity: "返乡照顾祖母的护士",
    tags: ["坚韧", "温柔", "清醒"],
    background: "为照顾生病的祖母回到小镇，一边打工一边复习考试。她把生活的重量都扛在肩上，却从不允许别人替她做决定。",
    analysis: "温栀是陆沉的镜像：一个把话憋住，一个把话咽下。她的清醒让这段感情始终维持在“差一点”的距离，也让结局更有余味。",
    timeline: [
      { label: "相遇", event: "在车站与陆沉共用同一个候车室的暖炉。" },
      { label: "离开", event: "祖母离世后决定去外地考试，未与陆沉当面告别。" },
      { label: "多年后", event: "收到一盒旧磁带，听见那句迟到的告白。" }
    ]
  },
  {
    id: "w03-c1",
    workId: "w03",
    name: "季明川",
    actor: "季明川",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20serious%20young%20man%20in%20a%20dark%20technical%20jacket%20against%20a%20futuristic%20indigo%20backdrop%20with%20dawn%20amber%20glow%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p05&orientation=portrait",
    identity: "物理学家 · 逆流研究者",
    tags: ["执拗", "天才", "责任感"],
    background: "最早发现“逆流期”规律的人，却因为一次公开争论失去了研究资格。多年来独自追踪时间装置的线索。",
    analysis: "季明川代表了“以理性包裹情感”的一类角色。他追查真相的动机里，藏着一份对搭档白璃的愧疚，这也是他最终选择和解的内在驱动力。",
    timeline: [
      { label: "发现", event: "在监测数据中察觉午夜时间会被装置收集。" },
      { label: "决裂", event: "因争论失去资格，与搭档白璃分道扬镳。" },
      { label: "黎明", event: "与白璃重建信任，联手关闭时间装置。" }
    ]
  },
  {
    id: "w03-c2",
    workId: "w03",
    name: "白璃",
    actor: "白璃",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20focused%20young%20woman%20in%20a%20futuristic%20coat%20against%20a%20dawn%20indigo%20backdrop%20with%20amber%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p06&orientation=portrait",
    identity: "装置工程师",
    tags: ["果决", "原则", "隐忍"],
    background: "逆流装置的核心工程师之一，因不满项目被滥用而离开团队。她比任何人都清楚装置一旦失控的代价。",
    analysis: "白璃是影片价值观的“底线”。她与季明川的对立并非敌意，而是两种守护方式的碰撞，最终的和解让科幻外壳落回人的情感。",
    timeline: [
      { label: "离开", event: "发现装置被别有用心的势力利用，主动退出团队。" },
      { label: "重逢", event: "被季明川说服，重新面对自己曾经建造的系统。" },
      { label: "抉择", event: "亲手关闭装置，为自己当年的作品画上句号。" }
    ]
  },
  {
    id: "w04-c1",
    workId: "w04",
    name: "何靖",
    actor: "何靖",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20weathered%20man%20in%20a%20worn%20cloak%20against%20a%20misty%20indigo%20river%20backdrop%20with%20warm%20dawn%20light%2C%20subtle%20film%20grain%2C%20illustrative%20wuxia%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p07&orientation=portrait",
    identity: "无名渡口摆渡人",
    tags: ["隐忍", "旧仇", "通透"],
    background: "十年前的灭门案让他失去全家，从此在渡口摆渡，不问来客。他以为沉默可以抵掉仇恨，直到宋辞带着旧信出现。",
    analysis: "何靖是典型的“放下型侠客”。人物张力不在于打斗，而在于他每一次压住怒气的克制，这使结局的释然更有重量。",
    timeline: [
      { label: "渡口", event: "收留自称有信的宋辞上船，暗生警惕。" },
      { label: "风浪", event: "夜航遇险，两人被迫说出各自的身世。" },
      { label: "到岸", event: "得知真相后，选择不报仇，放宋辞离开。" }
    ]
  },
  {
    id: "w04-c2",
    workId: "w04",
    name: "宋辞",
    actor: "宋辞",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20determined%20young%20woman%20in%20a%20dark%20traveling%20cloak%20against%20a%20misty%20indigo%20river%20backdrop%20with%20warm%20light%2C%20subtle%20film%20grain%2C%20illustrative%20wuxia%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p08&orientation=portrait",
    identity: "携信寻仇的旅人",
    tags: ["执念", "机敏", "矛盾"],
    background: "父辈死于同一场灭门案，她花了十年查证，只为把信交到“凶手”手里，完成复仇也完成自我交代。",
    analysis: "宋辞的功能是“引信”。她带来的不是仇恨本身，而是一个让何靖不得不直视过去的机会，两人互为镜面。",
    timeline: [
      { label: "登船", event: "带着旧信出现在渡口，表明来意。" },
      { label: "坦白", event: "风浪中说出自己十年查案的经历。" },
      { label: "放下", event: "在何靖放她离开后，撕掉了那封信。" }
    ]
  },
  {
    id: "w05-c1",
    workId: "w05",
    name: "长谷川凛",
    actor: "长谷川凛",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20anime%20character%20portrait%20of%20a%20young%20girl%20in%20a%20school%20uniform%20under%20a%20starry%20indigo%20night%20sky%20with%20warm%20star%20glow%2C%20soft%20film%20grain%2C%20illustrative%20anime%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p09&orientation=portrait",
    identity: "天文社成员",
    tags: ["好奇", "执着", "浪漫"],
    background: "从小听祖父讲外星故事长大，独自守着荒废的天文台，每晚向星空发送电波，坚信有人在听。",
    analysis: "凛是全片的“浪漫引擎”。她的相信让看似荒谬的跨星系通信成立，也让观众愿意跟随这份童话般的执念。",
    timeline: [
      { label: "发信", event: "在废弃天文台第一次收到来自星空的回应。" },
      { label: "相约", event: "与泽井悠约定每小时流星雨时“见面”。" },
      { label: "等待", event: "信号即将中断，她选择继续发送最后一封信。" }
    ]
  },
  {
    id: "w05-c2",
    workId: "w05",
    name: "泽井悠",
    actor: "泽井悠",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20anime%20character%20portrait%20of%20a%20young%20boy%20in%20a%20space%20flight%20suit%20against%20a%20deep%20indigo%20starfield%20with%20warm%20glow%2C%20soft%20film%20grain%2C%20illustrative%20anime%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p10&orientation=portrait",
    identity: "休眠飞船上的少年",
    tags: ["孤独", "温柔", "坚定"],
    background: "在长途航行中独自苏醒，负责看守飞船。漫长的寂静里，凛的电波成了他唯一还能称作“白天”的东西。",
    analysis: "泽井悠承担了“孤独的具象化”。他的存在让两个星球的距离不再是设定，而是一种能被感受的想念。",
    timeline: [
      { label: "苏醒", event: "在休眠舱中独自醒来，发现只剩自己一人值班。" },
      { label: "回应", event: "捕捉到凛的电波，第一次向宇宙回信。" },
      { label: "远行", event: "飞船航线偏移，仍坚持在最后信号中留下约定。" }
    ]
  },
  {
    id: "w06-c1",
    workId: "w06",
    name: "Nathan Cole",
    actor: "Nathan Cole",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20stern%20man%20in%20a%20navy%20raincoat%20against%20a%20foggy%20indigo%20harbour%20backdrop%20with%20cold%20light%2C%20subtle%20film%20grain%2C%20illustrative%20thriller%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p11&orientation=portrait",
    identity: "港口货运调度员",
    tags: ["务实", "多疑", "正义"],
    background: "在港口做了十五年调度，见惯了离奇档案。维斯塔号失踪案是他职业生涯里唯一没解开的结。",
    analysis: "Nathan 是观众的“眼睛”。他用普通人的怀疑一步一步逼近真相，让超自然的悬念落地为可信的调查过程。",
    timeline: [
      { label: "靠港", event: "发现失踪三年的维斯塔号自行驶回港口。" },
      { label: "登船", event: "与船员交谈，察觉所有人对三年记忆一片空白。" },
      { label: "揭晓", event: "从航海日志中拼出替身与谎言的真相。" }
    ]
  },
  {
    id: "w06-c2",
    workId: "w06",
    name: "Ivy Brooks",
    actor: "Ivy Brooks",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20composed%20woman%20in%20a%20grey%20coat%20against%20a%20foggy%20indigo%20harbour%20backdrop%20with%20soft%20cold%20light%2C%20subtle%20film%20grain%2C%20illustrative%20thriller%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p12&orientation=portrait",
    identity: "海事保险调查员",
    tags: ["冷静", "敏锐", "秘密"],
    background: "受保险公司委托登船核查，对维斯塔号的理赔案了如指掌，却对船上发生的事始终有所保留。",
    analysis: "Ivy 是悬念的“第二层”。她的保留让调查一次次转向，也让结局的身份反转显得顺理成章。",
    timeline: [
      { label: "登船", event: "以保险调查名义加入核查队伍，态度异常平静。" },
      { label: "矛盾", event: "被 Nathan 发现她掌握着未公开的旧档案。" },
      { label: "反转", event: "承认自己也在三年前的名单之中。" }
    ]
  },
  {
    id: "w07-c1",
    workId: "w07",
    name: "商野",
    actor: "商野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20young%20man%20in%20a%20dark%20wool%20coat%20against%20a%20moody%20indigo%20backdrop%20with%20warm%20rim%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p01&orientation=portrait",
    identity: "老照相馆馆主",
    tags: ["固执", "念旧", "深情"],
    background: "守着开了三十年的胶片照相馆，坚持用老方式冲印。一墙未取走的照片，是他对旧日顾客最笨拙的等待。",
    analysis: "商野代表“拒绝改变的人”。他的固执一度成为父女矛盾的根源，却在结尾被证明是对记忆另一种形式的守护。",
    timeline: [
      { label: "坚守", event: "拒绝拆迁，继续经营即将关门的老照相馆。" },
      { label: "冲突", event: "与女儿林知夏因搬迁问题激烈争吵。" },
      { label: "和解", event: "同意搬迁，却把整墙旧照亲手交到她手里。" }
    ]
  },
  {
    id: "w07-c2",
    workId: "w07",
    name: "林知夏",
    actor: "林知夏",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20young%20woman%20with%20soft%20wavy%20hair%20in%20a%20pale%20coat%20against%20a%20misty%20indigo%20backdrop%20with%20warm%20amber%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p02&orientation=portrait",
    identity: "大城市设计师",
    tags: ["要强", "孝顺", "成长"],
    background: "在大城市打拼多年，一心想把父亲接走。她以为自己是在照顾父亲，直到发现父亲守护的是整个家庭的记忆。",
    analysis: "林知夏承载了“和解”的主题。她从把旧照当作废品，到主动整理每一张底片，完成了对父辈与自己的双重理解。",
    timeline: [
      { label: "返乡", event: "回到老城劝说父亲关掉照相馆。" },
      { label: "翻找", event: "在一张张无人认领的旧照中拼出家庭缺失的十年。" },
      { label: "传承", event: "决定把老照片数字化，替父亲继续守下去。" }
    ]
  },
  {
    id: "w08-c1",
    workId: "w08",
    name: "Oliver Finch",
    actor: "Oliver Finch",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20quiet%20young%20man%20in%20a%20warm%20knit%20sweater%20against%20a%20snowy%20pale%20indigo%20backdrop%2C%20soft%20winter%20light%20and%20gentle%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p03&orientation=portrait",
    identity: "考古队队长",
    tags: ["严谨", "沉稳", "负责"],
    background: "长期在荒原带队发掘，重视证据与流程。面对无法解释的回声，他仍坚持用科学的方法一步步验证。",
    analysis: "Oliver 是理性的一方。他的存在让荒原的诡异始终被框在“可考据”的范围内，也让恐惧显得更加克制和真实。",
    timeline: [
      { label: "发掘", event: "带队抵达废弃村落，仪器首次录到低语。" },
      { label: "验证", event: "发现低语内容与队员明天的对话一致。" },
      { label: "撤离", event: "当队员开始“提前”说出结局，他决定中止发掘。" }
    ]
  },
  {
    id: "w08-c2",
    workId: "w08",
    name: "Grace Hale",
    actor: "Grace Hale",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20gentle%20young%20woman%20in%20a%20long%20grey%20coat%20against%20a%20snowy%20quiet%20indigo%20backdrop%20with%20soft%20warm%20glow%2C%20subtle%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p04&orientation=portrait",
    identity: "随队地质学者",
    tags: ["直觉", "敏锐", "勇敢"],
    background: "负责地层勘测，也是队伍里最早怀疑回声并非自然现象的人。她相信感觉，也愿意为之冒险求证。",
    analysis: "Grace 提供了“直觉视角”，与 Oliver 的理性形成互补。她坚持留下的选择，是推动真相浮出水面的关键。",
    timeline: [
      { label: "察觉", event: "在地层数据中发现回声的规律与人声一致。" },
      { label: "试探", event: "独自夜访石阵，录下第二轮低语。" },
      { label: "面对", event: "承认自己也在录到的结局名单之中。" }
    ]
  },
  {
    id: "w09-c1",
    workId: "w09",
    name: "한지우",
    actor: "한지우",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20serious%20young%20man%20in%20a%20dark%20technical%20jacket%20against%20a%20futuristic%20indigo%20backdrop%20with%20dawn%20amber%20glow%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p05&orientation=portrait",
    identity: "海边小镇邮差",
    tags: ["细心", "孤独", "清醒"],
    background: "每天骑车送信，熟悉镇上每个人的作息。正因为太熟悉日常，她才第一个察觉到日出重复的异样。",
    analysis: "韩지우 是“唯一清醒的人”。她的孤独感来自无人相信，而这份孤独恰恰是整部影片最核心的情绪。",
    timeline: [
      { label: "察觉", event: "发现连续七天的日出分秒不差。" },
      { label: "试探", event: "向镇上熟人求证，却发现没人记得昨天。" },
      { label: "面对", event: "决定独自在城市重播结束前留下记录。" }
    ]
  },
  {
    id: "w09-c2",
    workId: "w09",
    name: "류도현",
    actor: "류도현",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20focused%20young%20woman%20in%20a%20futuristic%20coat%20against%20a%20dawn%20indigo%20backdrop%20with%20amber%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p06&orientation=portrait",
    identity: "灯塔管理员",
    tags: ["沉静", "守护", "秘密"],
    background: "常年守着一座老旧灯塔，是镇上少数愿意认真听韩지우说话的人，却似乎早就知道些什么。",
    analysis: "류도현 的沉默制造了第二种悬念：她知道真相，却选择守护这个“重播的第七天”，为结局留足了想象空间。",
    timeline: [
      { label: "倾听", event: "耐心听完韩지우关于日出的怀疑。" },
      { label: "暗示", event: "在灯塔日志中留下与日期无关的记录。" },
      { label: "守护", event: "在最后一天选择让循环继续。" }
    ]
  },
  {
    id: "w10-c1",
    workId: "w10",
    name: "何靖",
    actor: "何靖",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20weathered%20man%20in%20a%20worn%20cloak%20against%20a%20misty%20indigo%20river%20backdrop%20with%20warm%20dawn%20light%2C%20subtle%20film%20grain%2C%20illustrative%20wuxia%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p07&orientation=portrait",
    identity: "退休探员",
    tags: ["老练", "愧疚", "求真"],
    background: "警队三十年，办过无数案子，退休前最后一件事却是重查自己年轻时经手的第一起命案。",
    analysis: "何靖是“自我审判”的角色。他追查的不只是凶手，更是当年那个选择妥协的自己，这让犯罪类型有了更深的情感落点。",
    timeline: [
      { label: "重查", event: "接到旧案重启通知，线索指向自己第一桩命案。" },
      { label: "动摇", event: "发现当年的结案真相只是一层体贴的谎言。" },
      { label: "自省", event: "决定亲手写下真正的结案报告。" }
    ]
  },
  {
    id: "w10-c2",
    workId: "w10",
    name: "苏未晞",
    actor: "苏未晞",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20determined%20young%20woman%20in%20a%20dark%20traveling%20cloak%20against%20a%20misty%20indigo%20river%20backdrop%20with%20warm%20light%2C%20subtle%20film%20grain%2C%20illustrative%20wuxia%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p08&orientation=portrait",
    identity: "案件记录员",
    tags: ["细致", "执着", "理性"],
    background: "负责整理旧案卷宗，是队里最早发现卷宗被篡改痕迹的人。她相信细节，也敢于质疑权威。",
    analysis: "苏未晞是“证据的化身”。她与何靖一老一少的搭档结构，让旧案的翻转显得既有逻辑支撑也有情感重量。",
    timeline: [
      { label: "发现", event: "在旧卷宗里找到被替换的两页记录。" },
      { label: "对峙", event: "与何靖一起核对当年的目击者证词。" },
      { label: "还原", event: "最终还原出被掩盖了二十年的真相。" }
    ]
  },
  {
    id: "w11-c1",
    workId: "w11",
    name: "沈砚",
    actor: "沈砚",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20anime%20character%20portrait%20of%20a%20young%20girl%20in%20a%20school%20uniform%20under%20a%20starry%20indigo%20night%20sky%20with%20warm%20star%20glow%2C%20soft%20film%20grain%2C%20illustrative%20anime%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p09&orientation=portrait",
    identity: "寒门进士 · 朝堂新贵",
    tags: ["隐忍", "谋略", "理想"],
    background: "出身寒门，靠一次科考入局。入朝后被三党当作棋子，却始终没有放弃心中那点“让天下少些不公”的念头。",
    analysis: "沈砚是全剧的“成长轴”。从被摆布到执棋，他付出的代价是一次次对旧友的取舍。角色弧光的完成度，决定了整部权谋剧的高度。",
    timeline: [
      { label: "入局", event: "科举及第，被卷入朝堂三党之争。" },
      { label: "破局", event: "识破各方算计，暗中推动更大的变量。" },
      { label: "收官", event: "在最后的朝会上公开底牌，成为真正的执棋者。" }
    ]
  },
  {
    id: "w11-c2",
    workId: "w11",
    name: "苏晚棠",
    actor: "苏晚棠",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20anime%20character%20portrait%20of%20a%20young%20boy%20in%20a%20space%20flight%20suit%20against%20a%20deep%20indigo%20starfield%20with%20warm%20glow%2C%20soft%20film%20grain%2C%20illustrative%20anime%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p10&orientation=portrait",
    identity: "掌书记女官",
    tags: ["聪慧", "克制", "清醒"],
    background: "掌管宫中文书，看惯了朝堂的起落。她比任何人更早看出沈砚的野心，也最早决定站在他这一边。",
    analysis: "苏晚棠是“旁观者中的清醒人”。她的选择不是爱情驱动，而是价值认同，让剧中情感线更含蓄也更有分量。",
    timeline: [
      { label: "相识", event: "在宫中与沈砚初次交锋，识破他的伪装。" },
      { label: "并肩", event: "冒险为沈砚传递关键文书。" },
      { label: "分别", event: "在局势最险时选择留下承担后果。" }
    ]
  },
  {
    id: "w12-c1",
    workId: "w12",
    name: "周牧野",
    actor: "周牧野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20stern%20man%20in%20a%20navy%20raincoat%20against%20a%20foggy%20indigo%20harbour%20backdrop%20with%20cold%20light%2C%20subtle%20film%20grain%2C%20illustrative%20thriller%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p11&orientation=portrait",
    identity: "新任教头 · 前主力",
    tags: ["要强", "负责", "不服输"],
    background: "五年前因判罚争议退队，此后远走他乡。重返母校当教练，只为把当年那口气重新争回来。",
    analysis: "周牧野是全剧的“精神内核”。他教的不只是技术，更是“还敢再来一次”的态度，这让竞技剧有了超越输赢的表达。",
    timeline: [
      { label: "退队", event: "因判罚争议离开校队，队伍随之解散。" },
      { label: "归来", event: "五年后出任教练，逐个找回旧队友。" },
      { label: "再战", event: "带队站上同一条跑道，把胜负留在场外。" }
    ]
  },
  {
    id: "w12-c2",
    workId: "w12",
    name: "陆沉",
    actor: "陆沉",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20composed%20woman%20in%20a%20grey%20coat%20against%20a%20foggy%20indigo%20harbour%20backdrop%20with%20soft%20cold%20light%2C%20subtle%20film%20grain%2C%20illustrative%20thriller%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p12&orientation=portrait",
    identity: "队医 · 老队员",
    tags: ["温和", "理性", "守护"],
    background: "当年队伍里最不起眼的一员，如今成了一名运动康复师。他回队，是为了让每个队友都别再受伤。",
    analysis: "陆沉提供了竞技剧里的“温度”。他的理性与周牧野的要强形成互补，让团队戏既有热血也有克制。",
    timeline: [
      { label: "响应", event: "第一个答应周牧野归队的邀请。" },
      { label: "调停", event: "在队员矛盾中充当缓冲的角色。" },
      { label: "守护", event: "在决赛前力主让有伤的队友退赛。" }
    ]
  },
  {
    id: "w13-c1",
    workId: "w13",
    name: "季明川",
    actor: "季明川",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20young%20man%20in%20a%20dark%20wool%20coat%20against%20a%20moody%20indigo%20backdrop%20with%20warm%20rim%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p01&orientation=portrait",
    identity: "海洋研究员",
    tags: ["专注", "敏感", "执着"],
    background: "长期在海上站点工作，习惯用数据解释一切。直到一只漂流瓶里的信，让他第一次意识到有些事无法被测量。",
    analysis: "季明川是“解谜者”，也是被谜题改变的人。他查的是同事失踪的真相，找回的却是自己面对失去的勇气。",
    timeline: [
      { label: "拾信", event: "在漂流瓶中读到失踪同事写给过去的信。" },
      { label: "寻访", event: "顺着线索找到每位收信人，发现他们都在等待。" },
      { label: "放手", event: "明白真相并非答案，选择把最后一封信放回海里。" }
    ]
  },
  {
    id: "w13-c2",
    workId: "w13",
    name: "白璃",
    actor: "白璃",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20young%20woman%20with%20soft%20wavy%20hair%20in%20a%20pale%20coat%20against%20a%20misty%20indigo%20backdrop%20with%20warm%20amber%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p02&orientation=portrait",
    identity: "电台主播",
    tags: ["温柔", "共情", "坚韧"],
    background: "在深夜电台做一档读信节目，是接收“漂流瓶”最多的人。她比谁都懂等待的滋味。",
    analysis: "白璃是全剧的“情感中心”。她与季明川的双线并行，让悬疑故事有了稳定的情绪落点。",
    timeline: [
      { label: "读信", event: "在节目中读出那封写给过去的信，引发共鸣。" },
      { label: "相遇", event: "与季明川一起寻找信中提到的收信人。" },
      { label: "告别", event: "在节目中替所有人说出了那句迟到的回信。" }
    ]
  },
  {
    id: "w14-c1",
    workId: "w14",
    name: "裴野",
    actor: "裴野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20quiet%20young%20man%20in%20a%20warm%20knit%20sweater%20against%20a%20snowy%20pale%20indigo%20backdrop%2C%20soft%20winter%20light%20and%20gentle%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p03&orientation=portrait",
    identity: "隐居山村的前朝官员",
    tags: ["淡泊", "通透", "有心事"],
    background: "厌倦朝堂倾轧后归隐山村，只想种田读书。可当水患旧案重提，他发现自己终究做不到置身事外。",
    analysis: "裴野是“入世与出世”的矛盾体。他的选择说明，真正的淡泊不是逃避，而是在看清后仍愿出手。",
    timeline: [
      { label: "归隐", event: "辞官入山，与世无争地生活。" },
      { label: "入局", event: "被水患旧案卷入，重新面对昔日同僚。" },
      { label: "抉择", event: "在村民安危与个人清誉之间选择前者。" }
    ]
  },
  {
    id: "w14-c2",
    workId: "w14",
    name: "林知夏",
    actor: "林知夏",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20gentle%20young%20woman%20in%20a%20long%20grey%20coat%20against%20a%20snowy%20quiet%20indigo%20backdrop%20with%20soft%20warm%20glow%2C%20subtle%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p04&orientation=portrait",
    identity: "游方女医",
    tags: ["善良", "果敢", "仗义"],
    background: "走遍各地行医，医术高明又不畏权贵。途经山村时因一场水患与裴野相识，从此改变了两人的轨迹。",
    analysis: "林知夏是故事的“推动力”。她主动、直接的行动方式，恰好补足了裴野的犹疑，两人形成鲜明对照。",
    timeline: [
      { label: "借宿", event: "因大雨借宿山村，与裴野初次相识。" },
      { label: "同行", event: "与裴野一起调查水患背后的旧案。" },
      { label: "别过", event: "案情了结后继续游方，却留下了一封未寄的信。" }
    ]
  },
  {
    id: "w15-c1",
    workId: "w15",
    name: "商野",
    actor: "商野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20serious%20young%20man%20in%20a%20dark%20technical%20jacket%20against%20a%20futuristic%20indigo%20backdrop%20with%20dawn%20amber%20glow%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p05&orientation=portrait",
    identity: "创业公司创始人",
    tags: ["要强", "埋头", "重情"],
    background: "毕业十年间一路创业，成功过也失败过。忙于事业疏远了所有旧友，直到那场葬礼把大家重新聚齐。",
    analysis: "商野代表“把生活抵押给目标的人”。他在剧中的最大变化，是学会承认自己也需要别人。",
    timeline: [
      { label: "重聚", event: "在葬礼上遇见十年未见的大学室友。" },
      { label: "回忆", event: "倒叙中浮现当年为事业放弃的友情与感情。" },
      { label: "和解", event: "主动联系旧友，把项目交由别人打理。" }
    ]
  },
  {
    id: "w15-c2",
    workId: "w15",
    name: "苏晚棠",
    actor: "苏晚棠",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20focused%20young%20woman%20in%20a%20futuristic%20coat%20against%20a%20dawn%20indigo%20backdrop%20with%20amber%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p06&orientation=portrait",
    identity: "中学教师",
    tags: ["淡然", "坚定", "清醒"],
    background: "毕业后回到老家当老师，生活平淡却安稳。十年间她始终是那几个好友里“联系大家”的那个人。",
    analysis: "苏晚棠是群像里的“稳定器”。她不争不抢，却是所有人情绪最终回流的地方。",
    timeline: [
      { label: "联络", event: "多年来默默维系着分散各地的旧友。" },
      { label: "坦言", event: "在重聚时说出每个人都不愿提起的往事。" },
      { label: "留下", event: "选择继续留在小城，成为大家的“归处”。" }
    ]
  }
];